import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "../../../ui/dialog"
import { Avatar, AvatarFallback, AvatarImage } from "../../../ui/avatar"
import { Card, CardContent } from "../../../ui/card"
import { UsersRound, X } from "lucide-react"
import { useIsMobile } from "../../../hooks/use-mobile"

const teamMembers = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Founder & CEO",
    bio:
      "Former social media executive with 10+ years of experience building creator platforms.",
    imageUrl: "https://i.pravatar.cc/150?img=32"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Chief Product Officer",
    bio:
      "Product visionary who previously led teams at top social media companies.",
    imageUrl: "https://i.pravatar.cc/150?img=11"
  },
  {
    id: 3,
    name: "Aisha Patel",
    role: "Head of Creator Relations",
    bio:
      "Former content creator with over 2M followers, now helping others succeed.",
    imageUrl: "https://i.pravatar.cc/150?img=48"
  },
  {
    id: 4,
    name: "David Rodriguez",
    role: "CTO",
    bio:
      "Tech leader with expertise in building scalable platforms for millions of users.",
    imageUrl: "https://i.pravatar.cc/150?img=12"
  },
  {
    id: 5,
    name: "Emma Wilson",
    role: "VP of Marketing",
    bio:
      "Digital marketing expert who has worked with hundreds of successful creators.",
    imageUrl: "https://i.pravatar.cc/150?img=33"
  },
  {
    id: 6,
    name: "James Taylor",
    role: "Head of Design",
    bio:
      "Award-winning UX/UI designer focused on creating intuitive creator tools.",
    imageUrl: "https://i.pravatar.cc/150?img=13"
  }
]

const TeamModal = ({ isOpen, onClose }) => {
  const isMobile = useIsMobile()

  return (
    <Dialog open={isOpen} onOpenChange={open => !open && onClose()}>
      <DialogContent
        className={`${
          isMobile ? "w-[95vw] p-4 max-w-[95vw]" : "max-w-4xl p-6"
        } max-h-[90vh] overflow-y-auto`}
      >
        <div className="flex items-center justify-between mb-2">
          <DialogHeader className="p-0">
            <DialogTitle className="flex items-center gap-2 text-xl sm:text-2xl">
              <UsersRound className="text-oye-purple h-5 w-5 sm:h-6 sm:w-6" />
              Our Team
            </DialogTitle>
            <DialogDescription className="text-sm sm:text-base">
              Meet the creative minds behind Oye Creators
            </DialogDescription>
          </DialogHeader>

          {isMobile && (
            <button
              onClick={onClose}
              className="rounded-full p-1 hover:bg-gray-100 transition-colors"
              aria-label="Close dialog"
            >
              <X className="h-5 w-5" />
            </button>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mt-4">
          {teamMembers.map(member => (
            <Card
              key={member.id}
              className="overflow-hidden hover:shadow-md transition-shadow duration-300"
            >
              <CardContent className="p-4 sm:p-6">
                <div className="flex flex-col items-center text-center mb-3 sm:mb-4">
                  <Avatar className="h-16 w-16 sm:h-24 sm:w-24 mb-2 sm:mb-3">
                    <AvatarImage src={member.imageUrl} alt={member.name} />
                    <AvatarFallback className="bg-oye-light-purple text-oye-purple text-lg sm:text-xl">
                      {member.name
                        .split(" ")
                        .map(n => n[0])
                        .join("")}
                    </AvatarFallback>
                  </Avatar>
                  <h3 className="font-bold text-base sm:text-lg">
                    {member.name}
                  </h3>
                  <p className="text-xs sm:text-sm text-oye-pink font-medium">
                    {member.role}
                  </p>
                </div>
                <p className="text-xs sm:text-sm text-gray-600">{member.bio}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default TeamModal
